// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f8883a49","703":"06b237e4","787":"e17831b9"}[chunkId] + ".chunk.js";
};